import axios from "axios";
import { getToken } from "../session";

const GET = async (endpoint) => {
  const response = await axios.get(endpoint, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  });
  return response;
};

export default GET;